export default {
    'invoice-no': 'Invoice No.',
    new: 'New',
    delete: 'Delete',
    account: 'Account',
    'invoice-date': 'Invoice date',
    warehouse: 'Warehouse',
    document: 'Ref. Doc.',
    'net-invoice': 'Grand amount',
    save: 'Save',
    edit: 'Edit',
    not: 'Non',
    posted: 'Posted',
    'add-invoice': 'Add invoice',
    create: 'Create',
    cancel: 'Cancel',

    'delete-entry': 'Delete item',
    'are-you-sure-you-want-to-delete-the-entry': 'Do you want to delete this item?',
    
    'delete-invoice': 'Delete this invoice',
    'are-you-sure-you-want-to-delete-the-invoice-that-will-delete-the-associated-bond': 'Do you want to  delete this invoice? the related bond will also be deleted?',
    notes: 'Notes',
    discount: 'Discount',
    total: 'Total',

    headers: {
        no: 'Serial',
        warehouse: 'Warehouse',
        material: 'Item',
        quantity: 'Quantity',
        count: 'Count',
        price: 'Price',
        'discount-percentage': 'Discount percent',
        'discount': 'Discount',
        'after-discount': 'Net amount',
        'notes': 'Notes',
    },

    'context-menu': {
        edit: 'Edit',
        delete: 'Delete'
    },
    receivables: 'Receivables',
    'total-receipts': 'Total receipts',
    'alert-message': 'Alert message',
    'confirm-message': 'The total receipts have become greater than the total. Do you want to continue?'
}